import React from 'react';

/**
 * The card shell used in the dashboard KPI row. Just the box —
 * children compose whatever lives inside (a `<Stat>`, a nested
 * sub-stat block, a progress bar, etc.).
 *
 * Spec from handoff: bg-surface, 1px border-default, r=10, 14px
 * padding, shadow-sm.
 */
export default function KpiCard({ children, style }) {
  return (
    <div
      style={{
        background: 'var(--bg-surface)',
        border: '1px solid var(--border-default)',
        borderRadius: 10,
        padding: 14,
        boxShadow: 'var(--shadow-sm)',
        display: 'flex',
        flexDirection: 'column',
        gap: 8,
        minWidth: 0,
        ...style,
      }}
    >
      {children}
    </div>
  );
}
